export const DATALAYER_REDUX_NAMESPACE =
  (process && process.env && process.env.TRACKING_DATALAYER_REDUX_NAMESPACE) || 'TRACKING_DATALAYER';
export const DATALAYER_WINDOW_KEY = (process && process.env && process.env.TRACKING_DATALAYER_WINDOW_KEY) || 'dStub';
export const TRACKING_INFO = (process && process.env && process.env.TRACKING_INFO) || 'pageTrackingInfo';
export const CLICK_TRACK_NAME = (process && process.env && process.env.TRACKING_CLICK_TRACK_NAME) || 'Click Event';
export const CHANGE_TRACK_NAME = (process && process.env && process.env.TRACKING_CHANGE_TRACK_NAME) || 'Change Event';
export const CUSTOM_TRACK_NAME = (process && process.env && process.env.TRACKING_CUSTOM_TRACK_NAME) || 'Custom Event';
export const PAGE_VIEW_TRACK_NAME = (process && process.env && process.env.TRACKING_PAGE_VIEW_TRACK_NAME) || 'pageView'; // This was previously defined in the apps as 'pageView'

export const SCREEN_VIEW = (process && process.env && process.env.SCREEN_VIEW) || 'screen_view';
export const SIGN_UP = (process && process.env && process.env.SIGN_UP) || 'sign_up';
export const PURCHASE = (process && process.env && process.env.PURCHASE) || 'purchase';
export const BEGIN_CHECKOUT = (process && process.env && process.env.BEGIN_CHECKOUT) || 'begin_checkout';
export const ERROR = (process && process.env && process.env.ERROR) || 'error';
export const VIEW_ITEM = (process && process.env && process.env.VIEW_ITEM) || 'view_item';
export const VIEW_ITEM_LIST = (process && process.env && process.env.VIEW_ITEM_LIST) || 'view_item_list';
export const LOGIN = (process && process.env && process.env.LOGIN) || 'login';

export const TRACKING_SERVER_CHECK_ENABLED =
  (process && process.env && process.env.TRACKING_SERVER_CHECK_ENABLED) || false;
export const TRACKING_SERVER_CHECK_COOKIE = 'fr_trkerr';
export const TRACKING_SERVER_CHECK_COOKIE_EXPIRATION = 1; // Interval time - Check once every hour.

export const TRACKING_LIBRARY_LOAD_INTERVAL = 100;
export const TRACKING_LIBRARY_LOAD_RETRY_LIMIT = 200;
export const TRACKING_LIBRARY_CHECK_COOKIE = 'fe_trkload';
export const TRACKING_LIBRARY_CHECK_COOKIE_EXPIRATION = 1; // Cookie expiration is 1 hour.

export const TRACKING_TRACING_ENABLED_COOKIE =
  (process && process.env && process.env.TRACKING_TRACING_ENABLED_COOKIE) || 'tracking_trace';
